import useCalculatePrintOrderPrice from '@apps/card/hooks/useCalculatePrintOrderPrice';
import { CardPriceModifiers, PriceConfig } from '@apps/card/routes/CardCustomizer/CardCustomizer.types';

export type PriceUpTo = 'cardFront' | 'cardBack' | 'envelope' | 'total';

const capitalize = (str: string) =>
  str.split(' ').reduce((acc, word) => {
    acc += word.charAt(0).toUpperCase() + word.slice(1);
    return acc;
  }, '');

export const usePriceSummaryController = (
  priceUpTo: PriceUpTo,
  config: PriceConfig,
  customizations: CardPriceModifiers
): Record<'card' | 'back' | 'envelope' | 'shipping', Array<[label: string, value: string | undefined]>> & { total: string } => {
  const {
    pricePerCard,
    pricePerReturnAddress,
    totalPricePerQuantity,
    totalPricePerCardShape,
    totalReturnAddressPrice,
    totalDeliveryPrice,
    totalPaperSizePrice,
    totalPaperTypePrice,
    totalEnvelopesPrice,
    totalBackLayoutPrice,
    total
  } = useCalculatePrintOrderPrice(priceUpTo, config, customizations);

  return {
    card: [
      [`Quantity: ${customizations.quantity} cards ${pricePerCard} each`, totalPricePerQuantity],
      [`Silhouette: ${capitalize(customizations.shape)}`, totalPricePerCardShape],
      ['Paper Type: Signature', totalPaperTypePrice],
      ['Size: Classic (5 x 7 inch)', totalPaperSizePrice]
    ],
    back: [[`Layout: ${capitalize(customizations.backLayout)}`, totalBackLayoutPrice]],
    envelope: [
      [`${customizations.quantity} White Signature Envelopes`, totalEnvelopesPrice],
      [`Return Address: ${capitalize(customizations.returnAddress)} ${pricePerReturnAddress}`, totalReturnAddressPrice]
    ],
    shipping: [[`${capitalize(customizations.delivery || '')} Shipping`.trim(), totalDeliveryPrice]],
    total
  };
};
